export const RESET_DIRTY = 'RESET_DIRTY';
export const FORCE_DIRTY_STATE = 'FORCE_DIRTY_STATE';
export const SET_ELEMENT_CHANGED = 'SET_ELEMENT_CHANGED';



// WEBPACK FOOTER //
// ./src/state/dirtyTracking/types.js